
  
  
  
  <div class="mt-4 mb-4">
    <div class="card-container">
  
      <!-- Total Applications -->
      <nb-card class="vendor-card">
        <nb-card-header>
          <div class="col-8">
            <span class="vendor-title">All Applications</span>
          </div>
          <div class="col-4 text-right">
            <div class="icon allvendor-icon">
              <svg width="29" height="25" viewBox="0 0 29 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18.2867 9.75C19.6157 9.75 20.693 10.8273 20.693 12.1562V18.6861C20.693 22.1041 17.9221 24.875 14.5041 24.875C11.086 24.875 8.31515 22.1041 8.31515 18.6861V12.1562C8.31515 10.8273 9.39247 9.75 10.7214 9.75H18.2867ZM7.80551 9.74871C7.32502 10.33 7.01499 11.0574 6.95203 11.8543L6.94015 12.1562V18.6861C6.94015 19.8502 7.20314 20.9529 7.67295 21.938C7.22043 22.0604 6.74361 22.125 6.2517 22.125C3.2132 22.125 0.75 19.6618 0.75 16.6234V12.1562C0.75 10.8937 1.72228 9.85835 2.9589 9.75798L3.15625 9.75L7.80551 9.74871ZM21.2027 9.74871L25.8437 9.75C27.1727 9.75 28.25 10.8273 28.25 12.1562V16.625C28.25 19.6625 25.7875 22.125 22.75 22.125C22.2599 22.125 21.7847 22.0609 21.3325 21.9406C21.7458 21.0772 21.999 20.1246 22.0558 19.1198L22.068 18.6861V12.1562C22.068 11.2415 21.7432 10.4027 21.2027 9.74871ZM14.5 0.125C16.7782 0.125 18.625 1.97183 18.625 4.25C18.625 6.52817 16.7782 8.375 14.5 8.375C12.2218 8.375 10.375 6.52817 10.375 4.25C10.375 1.97183 12.2218 0.125 14.5 0.125ZM23.4375 1.5C25.336 1.5 26.875 3.03902 26.875 4.9375C26.875 6.83598 25.336 8.375 23.4375 8.375C21.539 8.375 20 6.83598 20 4.9375C20 3.03902 21.539 1.5 23.4375 1.5ZM5.5625 1.5C7.46098 1.5 9 3.03902 9 4.9375C9 6.83598 7.46098 8.375 5.5625 8.375C3.66402 8.375 2.125 6.83598 2.125 4.9375C2.125 3.03902 3.66402 1.5 5.5625 1.5Z"
                  fill="#385EFF" />
              </svg>
            </div>
          </div>
        </nb-card-header>
        <nb-card-body>
          <span class="vendor-count">{{cardsCountsData?.TotalApplications}}</span>
        </nb-card-body>
      </nb-card>




        
      <!-- Pending at First Aid -->
      <nb-card class="vendor-card">
        <nb-card-header>
          <div class="col-8">
            <span class="vendor-title">Tagged to First Aid</span>
          </div>
          <div class="col-4 text-right">
            <div class="icon allvendor-icon">
             
              <svg width="29" height="25" viewBox="0 0 29 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M14.5 0C16.9853 0 19 2.01472 19 4.5C19 6.98528 16.9853 9 14.5 9C12.0147 9 10 6.98528 10 4.5C10 2.01472 12.0147 0 14.5 0ZM23.5 2C25.9853 2 28 4.01472 28 6.5C28 8.98528 25.9853 11 23.5 11C21.0147 11 19 8.98528 19 6.5C19 4.01472 21.0147 2 23.5 2ZM5.5 2C7.98528 2 10 4.01472 10 6.5C10 8.98528 7.98528 11 5.5 11C3.01472 11 1 8.98528 1 6.5C1 4.01472 3.01472 2 5.5 2ZM14.5 10C18.6421 10 22 13.3579 22 17.5C22 21.6421 18.6421 25 14.5 25C10.3579 25 7 21.6421 7 17.5C7 13.3579 10.3579 10 14.5 10Z"
                  fill="#FF5733" />
              </svg>
  
              
            </div>
          </div>
        </nb-card-header>
        <nb-card-body>
          <span class="vendor-count">{{cardsCountsData?.PendingAtFirstAid}}</span>
        </nb-card-body>
      </nb-card>
  


  
      <!-- Pending at GAO -->
      <nb-card class="vendor-card">
        <nb-card-header>
          <div class="col-8">
            <span class="vendor-title">TotalPendingAtGAO </span>
          </div>
          <div class="col-4 text-right">
            <div class="icon allvendor-icon">
              <svg width="29" height="25" viewBox="0 0 29 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18.2867 9.75C19.6157 9.75 20.693 10.8273 20.693 12.1562V18.6861C20.693 22.1041 17.9221 24.875 14.5041 24.875C11.086 24.875 8.31515 22.1041 8.31515 18.6861V12.1562C8.31515 10.8273 9.39247 9.75 10.7214 9.75H18.2867ZM7.80551 9.74871C7.32502 10.33 7.01499 11.0574 6.95203 11.8543L6.94015 12.1562V18.6861C6.94015 19.8502 7.20314 20.9529 7.67295 21.938C7.22043 22.0604 6.74361 22.125 6.2517 22.125C3.2132 22.125 0.75 19.6618 0.75 16.6234V12.1562C0.75 10.8937 1.72228 9.85835 2.9589 9.75798L3.15625 9.75L7.80551 9.74871ZM21.2027 9.74871L25.8437 9.75C27.1727 9.75 28.25 10.8273 28.25 12.1562V16.625C28.25 19.6625 25.7875 22.125 22.75 22.125C22.2599 22.125 21.7847 22.0609 21.3325 21.9406C21.7458 21.0772 21.999 20.1246 22.0558 19.1198L22.068 18.6861V12.1562C22.068 11.2415 21.7432 10.4027 21.2027 9.74871ZM14.5 0.125C16.7782 0.125 18.625 1.97183 18.625 4.25C18.625 6.52817 16.7782 8.375 14.5 8.375C12.2218 8.375 10.375 6.52817 10.375 4.25C10.375 1.97183 12.2218 0.125 14.5 0.125ZM23.4375 1.5C25.336 1.5 26.875 3.03902 26.875 4.9375C26.875 6.83598 25.336 8.375 23.4375 8.375C21.539 8.375 20 6.83598 20 4.9375C20 3.03902 21.539 1.5 23.4375 1.5ZM5.5625 1.5C7.46098 1.5 9 3.03902 9 4.9375C9 6.83598 7.46098 8.375 5.5625 8.375C3.66402 8.375 2.125 6.83598 2.125 4.9375C2.125 3.03902 3.66402 1.5 5.5625 1.5Z"
                  fill="#385EFF" />
              </svg>
            </div>
          </div>
        </nb-card-header>
        <nb-card-body>
          <span class="vendor-count">{{cardsCountsData?.TotalPendingAtGAO}}</span>
        </nb-card-body>
      </nb-card>

  
  
      <!-- Draft Applications -->
      <nb-card class="vendor-card">
        <nb-card-header>
          <div class="col-8">
            <span class="vendor-title">Draft Applications</span>
          </div>
          <div class="col-4 text-right">
            <div class="icon allvendor-icon">
  
  
  
              <svg width="29" height="25" viewBox="0 0 29 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" style="stop-color:#42a5f5;stop-opacity:1" />
                    <stop offset="100%" style="stop-color:#ab47bc;stop-opacity:1" />
                  </linearGradient>
                </defs>
                <path
                  d="M18 10C19.1046 10 20 10.8954 20 12V18C20 21.3137 17.3137 24 14 24C10.6863 24 8 21.3137 8 18V12C8 10.8954 8.89543 10 10 10H18ZM2 10H6V18C6 21.3137 8.68629 24 12 24C15.3137 24 18 21.3137 18 18V12C18 10.8954 18.8954 10 20 10H24"
                  stroke="url(#grad1)" stroke-width="2" stroke-dasharray="5,5" fill="none" />
              </svg>
  
  
  
  
            </div>
          </div>
        </nb-card-header>
        <nb-card-body>
          <span class="vendor-count">{{cardsCountsData?.TotalDraft}}</span>
        </nb-card-body>
      </nb-card>
  
  
      <!-- Approved Applications -->
      <nb-card class="vendor-card">
        <nb-card-header>
          <div class="col-8">
            <span class="vendor-title">TotalApproved</span>
          </div>
          <div class="col-4 text-right">
            <div class="icon allvendor-icon">
  
  
  
  
              <svg width="50" height="40" viewBox="0 0 50 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M30 15C31.1046 15 32 15.8954 32 17V30C32 34.4183 28.4183 38 24 38C19.5817 38 16 34.4183 16 30V17C16 15.8954 16.8954 15 18 15H30ZM5 15H9V30C9 34.4183 12.5817 38 17 38C21.4183 38 25 34.4183 25 30V17C25 15.8954 25.8954 15 27 15H41"
                  fill="#008000" fill-opacity="0.6" />
              </svg>
              
  
  
  
  
  
            </div>
          </div>
        </nb-card-header>
        <nb-card-body>
          <span class="vendor-count">{{cardsCountsData?.TotalApproved}}</span>
        </nb-card-body>
      </nb-card>
  
  
      <!-- Rejected Applications -->
      <nb-card class="vendor-card">
        <nb-card-header>
          <div class="col-8">
            <span class="vendor-title">TotalRejected</span>
          </div>
          <div class="col-4 text-right">
            <div class="icon allvendor-icon">
              <svg width="29" height="25" viewBox="0 0 29 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18.2867 9.75C19.6157 9.75 20.693 10.8273 20.693 12.1562V18.6861C20.693 22.1041 17.9221 24.875 14.5041 24.875C11.086 24.875 8.31515 22.1041 8.31515 18.6861V12.1562C8.31515 10.8273 9.39247 9.75 10.7214 9.75H18.2867ZM7.80551 9.74871C7.32502 10.33 7.01499 11.0574 6.95203 11.8543L6.94015 12.1562V18.6861C6.94015 19.8502 7.20314 20.9529 7.67295 21.938C7.22043 22.0604 6.74361 22.125 6.2517 22.125C3.2132 22.125 0.75 19.6618 0.75 16.6234V12.1562C0.75 10.8937 1.72228 9.85835 2.9589 9.75798L3.15625 9.75L7.80551 9.74871ZM21.2027 9.74871L25.8437 9.75C27.1727 9.75 28.25 10.8273 28.25 12.1562V16.625C28.25 19.6625 25.7875 22.125 22.75 22.125C22.2599 22.125 21.7847 22.0609 21.3325 21.9406C21.7458 21.0772 21.999 20.1246 22.0558 19.1198L22.068 18.6861V12.1562C22.068 11.2415 21.7432 10.4027 21.2027 9.74871ZM14.5 0.125C16.7782 0.125 18.625 1.97183 18.625 4.25C18.625 6.52817 16.7782 8.375 14.5 8.375C12.2218 8.375 10.375 6.52817 10.375 4.25C10.375 1.97183 12.2218 0.125 14.5 0.125ZM23.4375 1.5C25.336 1.5 26.875 3.03902 26.875 4.9375C26.875 6.83598 25.336 8.375 23.4375 8.375C21.539 8.375 20 6.83598 20 4.9375C20 3.03902 21.539 1.5 23.4375 1.5ZM5.5625 1.5C7.46098 1.5 9 3.03902 9 4.9375C9 6.83598 7.46098 8.375 5.5625 8.375C3.66402 8.375 2.125 6.83598 2.125 4.9375C2.125 3.03902 3.66402 1.5 5.5625 1.5Z"
                  fill="#385EFF" />
              </svg>
            </div>
          </div>
        </nb-card-header>
        <nb-card-body>
          <span class="vendor-count">{{cardsCountsData?.TotalRejected}} </span>
        </nb-card-body>
      </nb-card>
  
      <!-- Repeat similar structure for other cards -->
    </div>
  </div>
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  <!-- My Applications Section -->
  
  
 
  
  
  
  <div class="row dashboard mt-3">
    <div class="col-lg-6">
      <nb-card>
        <nb-card-header><b>Applications by Type & Status</b></nb-card-header>
        <nb-card-body>
          <div style="height: 325px;">
  
            <app-bar-chart [data]="barChartData"></app-bar-chart>
  
          </div>
        </nb-card-body>
      </nb-card>
    </div>


    <div class="col-lg-6">
      <nb-card>
        <nb-card-header><b>Pending Aging Buckets</b></nb-card-header>
        <nb-card-body>
          <div style="height: 325px;">
  
            <app-doughnut-chart [data]="doughnutChartData"></app-doughnut-chart>
  
          </div>
        </nb-card-body>
      </nb-card>
    </div>



  </div>
  
  
  
  
  
  
  
  
  <div class="row dashboard mt-3">
 


        <!-- <div class="col-lg-6">
      <nb-card>
        <nb-card-header><b>Payment Terms Wise Vendors</b></nb-card-header>
        <nb-card-body>
          <div style="height: 325px;">
            <app-pie-chart></app-pie-chart>
  
          </div>
        </nb-card-body>
      </nb-card>
    </div> -->
  



    <!-- <div class="col-lg-6">
      <nb-card>
        <nb-card-header><b>Payment Terms Wise Vendors</b></nb-card-header>
        <nb-card-body>
          <div style="height: 325px;">
            <app-pie-chart></app-pie-chart>
  
          </div>
        </nb-card-body>
      </nb-card>
    </div> -->
  
  </div>
  
  
  
  
  
  
  
  
  
  <!-- <div class="row dashboard mt-3">
    <div class="col-lg-12">
      <nb-card>
        <nb-card-header><b>MSME Vendors per category</b></nb-card-header>
        <nb-card-body>
          <div>
            <canvas id="msmeBarChart"></canvas>
          </div>
        </nb-card-body>
      </nb-card>
    </div>
  </div> -->